import React, { useState, useEffect, useMemo } from "react";
import axiosInstance from '../axios.config';
import { ToastContainer, toast } from 'react-toastify';
import { UsersTable } from "../components/Users/UsersTable";
import { UpdateUserModal } from "../components/Users/UpdateUserModal";
import { CreateUserModal } from "../components/Users/CreateUserModal";
import { Box, Typography } from "@mui/material";
import { ContentBlock } from "../shared/sharedStyles";
import { FilteringBlock } from "../components/Users/FilteringZone";

const Users = () => {
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));
    const [showEdit, setShowEdit] = useState(false);
    const [showadd, setShowAdd] = useState(false);

    const [eName, setEName] = useState('');
    const [ePassword, setEPassword] = useState('');
    const [eEmail, setEEmail] = useState('');

    const [search, setSearch] = useState('');
    const [roleFilter, setRoleFilter] = useState('');
    const [usersList, setUsersList] = useState([]);
    // const [filteredUsersList, setFilteredUsersList] = useState([]);
    const [storeLocations, setStoreLocations] = useState({});
    const [userToEdit, setUserToEdit] = useState(null);

    const [updating, setUpdating] = useState(false);
    const [deletingUser, setDeletingUser] = useState(null);

    useEffect(() => {
        getData();
        getStoreData();
    }, []);

    const getStoreData = async () => {
        try {
            const response = await axiosInstance.get(`/Store`);
            const storeLocationMap = {};
            response.data.forEach(store => {
                storeLocationMap[store.storeID] = store.storeLocation;
            });
            setStoreLocations(storeLocationMap);
        } catch (error) {
            // console.error('Error fetching store locations', error);
        }
    }

    const getData = async () => {
        try {
            const result = await axiosInstance.get("/User");
            setUsersList(result.data);
        } catch (error) {
            console.log(error);
        }
    };

    const filteredUsersList = useMemo(() => {
        return usersList.filter(user => {
            const usernameMatch =
                user.userName
                    ?.toLowerCase()
                    .includes(search.toLowerCase());

            const roleMatch =
                user.role
                    ?.toLowerCase()
                    .includes(roleFilter.toLowerCase());

            return usernameMatch && roleMatch;

        });

    }, [usersList, search, roleFilter]);

    const handleShowAdd = () => setShowAdd(true);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowEdit = () => setShowEdit(true);
    const handleCloseEdit = () => setShowEdit(false);

    const handleEdit = (email) => {
        handleShowEdit();
        axiosInstance.get(`/User/${email}`)
            .then((result) => {
                setUserToEdit(result.data)
            })
            .catch((error) => {
                // console.log(error)
            })
    }

    const handleDelete = async (id) => {
        if (!window.confirm(lngsltd["Are you sure to delete this User"] + "?")) {
            return;
        }
        setDeletingUser(id);
        try {
            await axiosInstance.delete(`/User/${id}`);
            await getData();      // Wait until users are reloaded
            toast.success(lngsltd["User has been deleted"]);
        }
        catch (error) {
            toast.error(error.response?.data || "Error deleting user");
        }
        finally {
            setDeletingUser(null);
        }
    };

    const handleUpdate = async (email, updateUserObj) => {
        if (updating) return;
        setUpdating(true);
        try {
            const data = {
                firstName: updateUserObj.firstName,
                lastName: updateUserObj.lastName,
                password: updateUserObj.password,
                role: updateUserObj.role,
                StoreId: updateUserObj.store
            };

            await axiosInstance.put(`/User/${email}`, data);
            await getData();
            handleCloseEdit();
            toast.success(lngsltd["User has been updated"]);
        }
        catch (error) {
            toast.error(error.response?.data || "Error updating user");
        }
        finally {
            setUpdating(false);
        }
    };
    const handleCreateUser = async (createUserObj) => {
        console.log("CreateUserObj:", createUserObj);
        try {
            const data = {
                "firstName": createUserObj.firstName,
                "lastName": createUserObj.lastName,
                "userEmail": createUserObj.email,
                "password": createUserObj.password,
                "role": createUserObj.role,
                "StoreId": createUserObj.store
            };
            console.log("Payload sent:", data);
            const result = await axiosInstance.post("/User", data);
            // refresh grid
            await getData();
            // close modal
            setShowAdd(false);
            toast.success(result.data);
        }
        catch (error) {
            toast.error(
                error.response?.data || "Error creating user"
            );
        }
    };

    const handlesend = async (id) => {
        try {
            const result = await axiosInstance.get(`/User/${id}`);

            setEName(result.data.userName);
            setEPassword(result.data.password);
            setEEmail(result.data.userEmail);

            const emailInputs = {
                recipientEmail: result.data.userEmail,
                userName: result.data.userName,
                password: result.data.password
            };
            await axiosInstance.post(`/User/slgemail`, emailInputs);
            toast.success(lngsltd['Email has been sent']);
        } catch (error) {
            toast.error(lngsltd['Error sending email']);
        }
    }

    const handleClearFilters = () => {
        setSearch('');
        setRoleFilter('');
    }

    return (
        <Box className='fullHW' px={6} py={4} display="flex" flexDirection="column">
            <Typography variant="h5" fontWeight={600}>List of Users</Typography>
            <ToastContainer
                autoClose={2000}
                progressClassName='custom-toast-progress-bar' />

            <ContentBlock sx={{ flexGrow: 1, display: "flex", flexDirection: "column", py: 4, "& p": { m: 0 } }}>
                {/* Filter inputs */}
                <FilteringBlock
                    handleShowAdd={handleShowAdd}
                    lngsltd={lngsltd}
                    search={search}
                    setSearch={setSearch}
                    roleFilter={roleFilter}
                    setRoleFilter={setRoleFilter}
                    handleClearFilters={handleClearFilters}
                />

                <Box mt={2} flexGrow={1} overflow="hidden" width="90%">
                    <UsersTable
                        lngsltd={lngsltd}
                        data={usersList}
                        filteredData={filteredUsersList}
                        storeLocations={storeLocations}
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        handlesend={handlesend}
                        deletingUser={deletingUser}
                    />
                </Box>
            </ContentBlock>

            {/* Modal for updating user */}
            <UpdateUserModal
                show={showEdit}
                handleClose={handleCloseEdit}
                lngsltd={lngsltd}
                userToEdit={userToEdit}
                storeLocations={storeLocations}
                handleUpdate={handleUpdate}
                updating={updating}
            />

            {/* Modal for adding new user */}
            {<CreateUserModal
                showadd={showadd}
                handleCloseAdd={handleCloseAdd}
                lngsltd={lngsltd}
                storeLocations={storeLocations}
                handleSave={handleCreateUser}
            />}
        </Box>
    )

}

export default Users